export function parseXeroDate(value: unknown): Date | null {
  if (value === null || value === undefined) return null;
  if (value instanceof Date) return value;

  // Numbers: allow ms (13 digits) or seconds (10 digits-ish)
  if (typeof value === 'number' && Number.isFinite(value)) {
    const ms = value < 1e12 ? value * 1000 : value;
    const d = new Date(ms);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const s = String(value).trim();
  if (!s) return null;

  // Xero can return JSON dates like:
  // "/Date(1704067200000+0000)/" or "/Date(1704067200000)/" or "Date(1704067200000)"
  const m = s.match(/Date\((\d+)(?:[+-]\d+)?\)/);
  if (m) {
    const ms = Number(m[1]);
    if (!Number.isNaN(ms)) {
      const d = new Date(ms);
      return Number.isNaN(d.getTime()) ? null : d;
    }
  }

  // Handle YYYY-MM-DD explicitly as local midnight (avoids odd parsing in some browsers)
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    const d = new Date(`${s}T00:00:00`);
    return Number.isNaN(d.getTime()) ? null : d;
  }

  const d = new Date(s);
  return Number.isNaN(d.getTime()) ? null : d;
}

export function formatXeroDate(value: unknown, locale = 'en-AU'): string {
  const d = parseXeroDate(value);
  if (!d) return '-';
  return d.toLocaleDateString(locale, { day: '2-digit', month: 'short', year: 'numeric' });
}

